<div class="backdrop" (click)="onClose()">
    <div class="alert-box">
        <p>{{ message }}</p>
        <div class="alert-box-actions">
            <button class="btn btn-primary"  (click)="onClose()">Close</button>
        </div>
    </div>
</div>